import React from 'react';

const Code = ({ 
  height = '48px', 
  width = '48px', 
  color = '#335262', 
  secondaryColor = '#EA9860'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>code</title>
    <g>
      <path d="M12,34.828l-9.414-9.414c-0.781-0.781-0.781-2.047,0-2.828L12,13.172L14.829,16l-8,8l8,8L12,34.828z" fill={color} />
      <path d="M36,34.828L33.171,32l8-8l-8-8L36,13.172l9.414,9.414c0.781,0.781,0.781,2.047,0,2.828L36,34.828z" fill={color} />
      <rect height="4" width="36.985" fill={secondaryColor} transform="matrix(0.2427 -0.9701 0.9701 0.2427 -5.1069 41.4583)" x="5.507" y="22"/>
    </g>
  </svg>
);

export default Code;
